import { render, staticRenderFns } from "./InputWeight.vue?vue&type=template&id=638dc9cd"
import script from "./InputWeight.vue?vue&type=script&lang=js"
export * from "./InputWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports